import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { GolfCourse, GolfCourseListResponse, ScoreCardResponse, VectorGPSResponse } from '../../model/igolf.model';

@Injectable({
  providedIn: 'root',
})
export class IGolfSourceService {
  apiUrl = environment.apiUrl + 'igolf/courses';
  private _httpClient = inject(HttpClient);
  getAllCourses(
    active: string='',
    referenceLongitude: number=0,
    referenceLatitude: number=0,
    radius: number=0,
    page: number=1,
    resultsPerPage: number = 10
  ) {
    return this._httpClient.get<GolfCourseListResponse>(this.apiUrl, {
      params:{
        referenceLongitude, referenceLatitude, page, resultsPerPage,radius
      }
    });
  }
  getCourseDetailFromId(courseId: string){
    return this._httpClient.get<GolfCourse>(this.apiUrl+'/'+ courseId)
  }
  getTees(courseId: string){
    return this._httpClient.get<unknown>(this.apiUrl+'/'+ courseId+'/tees', {
      params: {
        detailLevel:"1"
      }
    })
  }
  getCourseScoreCard(courseId: string){
    return this._httpClient.get<ScoreCardResponse>(`${this.apiUrl}/${courseId}/scorecard`);
  }
  getGpsDetail(courseId: string){
    return this._httpClient.get<unknown>(`${this.apiUrl}/${courseId}/gps`);
  }
  getGpSVector(courseId:string){
    return this._httpClient.get<VectorGPSResponse>(`${this.apiUrl}/${courseId}/gps-vector`);
  }
}
